import {bluetoothSvg as Icon__small__bluetoothSvg} from '../Icon__small/Icon__small--bluetooth.js';

export var bluetooth = {
  name: 'bluetooth',
  category: 'icon',
  colorable: true,
  svg: Icon__small__bluetoothSvg,
};
